export default __webpack_public_path__ + "maps-examples-fly-to-960-2f0c74fcfec26e59281f5852c7e9acd3.png";